import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Theme, Container } from '@material-ui/core'
import DefaultLayout from '@src/components/DefaultLayout'
import StructureSearchDraw, {
  StructureSearchInitialQueryVars,
} from './StructureSearchDraw'
import RecentStructureSearches from './RecentStructureSearches'
import { useRecentStructureSearches } from './structureSessionStorageUtils'

export const useStyles = makeStyles((theme: Theme) => {
  return {
    body: {
      paddingTop: theme.spacing(5),
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-evenly',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        maxWidth: 'initial',
      },
    },
    title: {
      fontSize: theme.typography.pxToRem(32),
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(10),
      marginLeft: theme.spacing(10),
    },
    containerBox: {
      width: '75%',
      '@media (max-width: 768px)': {
        width: '100%',
      },
    },
  }
})

const StructureSearch = () => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const [recentSearchSelection, setRecentSearchSelection] = useState(
    {} as StructureSearchInitialQueryVars
  )
  const recentStructures = useRecentStructureSearches()

  return (
    <DefaultLayout className={classes.body}>
      <Container maxWidth="lg" className={classes.container}>
        <Box mt={5} className={classes.containerBox}>
          <div className={classes.title}>
            {formatMessage({
              id: 'STRUCTURE_SEARCH',
              defaultMessage: 'Structure Search',
            })}
          </div>
          <StructureSearchDraw recentSearchSelection={recentSearchSelection} />
        </Box>
        <RecentStructureSearches
          setRecentSearchSelection={setRecentSearchSelection}
          recentStructures={recentStructures}
        />
      </Container>
    </DefaultLayout>
  )
}

export default StructureSearch
